import {
    saveUserActivity,
    getCustomerNames,
    postUserAuth,
    getDropDownList,
    getCustomerLevelDetails,
    getTradeLevelDetails,
    saveDashboardFilter,
    getDistinctSalesManager,
    getDistinctAccountOwners,
    getMonthlyPipelineDetails,
    getTradeLevelReport,
    getProductLevelReport,
    getSalesRegionLevelReport,
    getExportRegionLevelReport,
    getExportRegionTradeLevelReport,
    getSalesAreaLevelReport,
    getSalesCountryLevelReport,
    saveSFDCUserClick
} from "@/config/apiEndPoints";

const saveUserActivityDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveUserActivity}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 409;
        }
    };
};

const getCustomerDetails = async (data, idToken) => {
    return {
        method: "get",
        url: `${getCustomerNames}?customer=${data}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status == 500 || status == 400 || status == 401
        }
    };
};

const getDistinctSalesManagerDetails = async (data, idToken) => {
    return {
        method: "get",
        url: `${getDistinctSalesManager}?salesManager=${data}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status == 500 || status == 400 || status == 401
        }
    };
};

const getDistinctAccountOwnersDetails = async (data, idToken) => {
    return {
        method: "get",
        url: `${getDistinctAccountOwners}?accOwner=${data}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status == 500 || status == 400 || status == 401
        }
    };
};

const authorizeUser = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${postUserAuth}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: userEmail,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getDropDownListDetails = async (data, idToken) => {
    return {
        method: "post",
        url: `${getDropDownList}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getCustomerLevelDetailsList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getCustomerLevelDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getTradeLevelDetailsList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getTradeLevelDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const saveDashboardFilterList = async (data, idToken) => {
    return {
        method: "post",
        url: `${saveDashboardFilter}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getMonthlyPipelineDetailsList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getMonthlyPipelineDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getTradeLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getTradeLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getProductLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getProductLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getSalesRegionLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getSalesRegionLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getExportRegionLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getExportRegionLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getSalesAreaLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getSalesAreaLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getExportRegionTradeLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getExportRegionTradeLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const getSalesCountryLevelReportList = async (data, idToken) => {
    return {
        method: "post",
        url: `${getSalesCountryLevelReport}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}

const saveSFDCUserClickList = async (data, idToken) => {
    return {
        method: "post",
        url: `${saveSFDCUserClick}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: data,
        validateStatus(status){
            return status >= 200 && status < 300 || status === 500 || status === 400 || status === 401
        }

    };
}



export default {
    saveUserActivityDetails,
    authorizeUser,
    getDropDownListDetails,
    getCustomerLevelDetailsList,
    getTradeLevelDetailsList,
    getCustomerDetails,
    saveDashboardFilterList,
    getDistinctSalesManagerDetails,
    getDistinctAccountOwnersDetails,
    getMonthlyPipelineDetailsList,
    getTradeLevelReportList,
    getProductLevelReportList,
    getSalesRegionLevelReportList,
    getExportRegionLevelReportList,
    getSalesAreaLevelReportList,
    getExportRegionTradeLevelReportList,
    getSalesCountryLevelReportList,
    saveSFDCUserClickList
};
